import {InquiryMultiField} from "./inquiry_multi_field";

export const PersonEmailFieldConfig = {
    baseHtmlClass: 'inquiry_field--person_email',
    selector: '.inquiry_field--person_email'
}

export class PersonEmailField extends InquiryMultiField {

    static new(InquiryForm) {
        if (!InquiryForm.element) { return null }
        const element = InquiryForm.element.querySelector(PersonEmailFieldConfig.selector);
        if (element) { return new PersonEmailField(element, InquiryForm) }
    }

    constructor(id_or_element, InquiryForm) {
        super(id_or_element, InquiryForm);
    }

    typecastValue(value) {
        if (value === '' || value === null) { return null }
        value = String(value);
        return value;
    }

    hasValue() {
        return this.value !== null;
    }

    beforeUpdate() {
        this.errorChecking = true;
        // if (this.InquiryForm.hasCurrentPerson()) { this.errorChecking = false }; // No error checking when we have a current person.
        // if (!this.InquiryForm.hasCommittedMinimumRequirements()) { this.errorChecking = false }; // No error checking until user has committed the minimum requirements.
        super.beforeUpdate();
    }

    appendErrors() {
        if (!this.hasValue()) { this.errors.push(`${ this.label } must be your email address.`) }
    }

}